import { render, staticRenderFns } from "./customer-region.vue?vue&type=template&id=631fd37a"
import script from "./customer-region.vue?vue&type=script&lang=js"
export * from "./customer-region.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports